import { Avatar, Box } from '@mui/material';
import Content from '../../Components/Content/Content';
import FactoryIcon from '@mui/icons-material/Factory';
import Headline from '../../Components/Headline/Headline';
import BrandForm from '../../Forms/BrandForm';

function Create()
{
    return <Content>
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <FactoryIcon />
            </Avatar>
            <Headline size="h5">Marke hinzufügen</Headline>
            <BrandForm />
        </Box>
    </Content>
}

export default Create;
